module.exports = __webpack_public_path__ + "assets/img/xcj.780afd29.png";